module.exports = __webpack_public_path__ + "img/os_icon.da4aee77.svg";